import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import {msg} from '@lit/localize';
import store from '../../../store';
import {cssProperties} from '../../../css/cssProperties';

@customElement('visual-lightprofile-summary-tender-text')
export class VisualLightprofileSummaryTenderText extends connect(store)(LitElement) {

	static styles = [
		css`
			.tenderText {
				padding: 50px 30px;
			}

			.tenderTextContainer {
				display: grid;
				grid-auto-flow: dense;
				grid-template-columns: 3fr 9fr;
				gap: 0px;
				padding: 0 16px 0 0;
			}

			.description {
				color: var(--color-grey4);
				font: var(--font-summary-paragraph);
				line-height: 22px;
				max-width: 70%;
				text-align: left;
			}

			.description h5 {
				color: var(--color-white);
			}

			@media (max-width: 768px) {
				.tenderText {
					padding: 50px var(--small-padding);
				}

				.tenderTextContainer {
					display: block;
					padding: 0;
				}

			}
		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	render() {
		return html`
		<section class="tenderText">
			<div class="tenderTextContainer">
				<div class="description">
					<h5>${msg('Tender Text')}</h5>
				</div>
				<light-tender-text theme="white"></light-tender-text>
			</div>
		</section>
		`;
	}
}

